import React from "react";
import { CustomGrid as Grid } from "../../customComponents/components";
import SSOComponent from "@techsoftware/happay-widgets/SSOComponent";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import Api from "../../constants/api";
import * as LoginAction from "../../actions/loginaction";
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";
import Common from "../../constants/common";
import BASEURL from "../../../config";
import i18n from "../../i18nNext";
import poweredByHappay from "../../../public/assets/images/poweredByHappayImg.svg";

export default class SSOSiginPage extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const { search = "" } = window.location;
        if (search.includes("domain_name=")) {
            let domain = search.split("domain_name=")[1];
            if (domain) {
                if (domain.includes("&")) {
                    domain = domain.split("&")[0];
                }
                this.handleSubmit(domain);
            }
        }
    }
    returnBackLoginLink = () => {
        return (
            <Link className="pointer font-12 fw-500 primary-color" to="/login">
                Login via email/mobile
            </Link>
        );
    };
    handleSubmit = companyName => {
        const hardwareId = sessionStorage.getItem("hardware_id");
        const gmailAddonInfo = sessionStorage.getItem("gmail-addon-info");
        const reqData = { domain: companyName, source: "expense-web" };
        if (gmailAddonInfo && hardwareId) {
            const param = Api.parseURLParams(gmailAddonInfo);
            reqData.source = "gmail-addon";
            reqData.redirect_url = param && param.redirect_url && param.redirect_url[0].replace("https://","");
        }
        LoginAction._checkSSO(reqData);
    };
    render() {
        const { ProductLogo, breakPoints, privacyPolicyUrl, termOfUseUrl } = this.props;
        return (
            <Grid isWidgetComp>
                <SSOComponent
                    containerClassName={`signin-container ${Common._checkIfHdfcUrl() ? 'hdfcPortal': 'happayPortal'}`}
                    logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                    SSOLoginClick={this.handleSubmit}
                    isCantSignInRequired
                    inputHintText="e.g. vatech"
                    breakPoints={breakPoints}
                    privacyPolicyText={!Common._checkIfHdfcUrl() && "Privacy Policy"}
                    termOfUseText={!Common._checkIfHdfcUrl() && "Terms of Use"}
                    termOfUseUrl={!Common._checkIfHdfcUrl() && termOfUseUrl}
                    privacyPolicyUrl={!Common._checkIfHdfcUrl() && privacyPolicyUrl}
                    scrollIntoView={isMobile}
                    scrollOffset={100}
                    androidAppUrl={
                        !Common._checkIfHdfcUrl() &&
                        "https://play.google.com/store/apps/details?id=com.happay.android.v2&hl=en"
                    }
                    iphoneAppUrl={
                        !Common._checkIfHdfcUrl() &&
                        "https://itunes.apple.com/za/app/happay-enterprise/id1169381152?mt=8"
                    }
                    backLoginLink={this.returnBackLoginLink()}
                    footerSubHeader={
                        Common._checkIfHdfcUrl() && (
                            <div className="d-flex alignItemCenter">
                                {i18n.t("lbl.poweredBy")}
                                <img
                                    src={poweredByHappay}
                                    width="80"
                                    className="margin-lr-5"
                                />
                            </div>
                        )
                    }
                />
            </Grid>
        );
    }
}
